class EventDrivenDispatchers {
  static types = {
    UserSignaturesComplete: 'UserSignaturesComplete',
    SignatureIRDocsGenerated: 'SignatureIRDocsGenerated',
    StepValidation: 'step-validation',
    BillingDataValidation: 'billing-validation',
    SubmitUtilityDataComplete: 'SubmitUtilityDataComplete',
    Debugger: 'Debugger',
  };

  static dispatch(type, data) {
    document.dispatchEvent(
      new CustomEvent(type, {
        bubbles: true,
        detail: data,
      })
    );
    // if(!!DEBUG) {
    //     console.log(`new dispatch for ${type} with data`, data);
    // }
  }

  static listen(type, listener, multi) {
    let listenClosure = (event) => {
      if (!multi) {
        remover();
      }
      listener(event);
    };

    let remover = () => document.removeEventListener(type, listenClosure, false);

    document.addEventListener(type, listenClosure, false);
    // if(!!DEBUG) {
    //     console.log(`new listener for ${type}`);
    // }
    return remover;
  }

  static async emitAndWait(typeDispatch, dataDispatch, typeWait) {
    //start listening before! we dispatch
    let promise = EventDrivenDispatchers.listenAsPromise(typeWait);

    EventDrivenDispatchers.dispatch(typeDispatch, dataDispatch);

    return promise;
  }

  static async listenAsPromise(type) {
    return new Promise((resolve, reject) => {
      EventDrivenDispatchers.listen(
        type,
        (evt) => {
          let eventDetail = evt.details || evt.detail;
          if (eventDetail instanceof Error) {
            return reject(eventDetail);
          }
          return resolve(eventDetail);
        },
        false
      );
    });
  }

  static async __listenAndRespond(listenType, responseFnc, responseType) {
    EventDrivenDispatchers.listen(
      listenType,
      async (request) => {
        if (typeof responseFnc === 'function') {
          try {
            let data = await responseFnc(request);
            EventDrivenDispatchers.dispatch(responseType, data);
          } catch (err) {
            EventDrivenDispatchers.dispatch(responseType, err);
          }
        } else {
          EventDrivenDispatchers.dispatch(responseType);
        }
      },
      true
    );
  }

  static async callResponse(type, data) {
    return EventDrivenDispatchers.emitAndWait(`${type}-call`, data, `${type}-response`);
  }

  static listenAndRespond(type, responseFnc) {
    EventDrivenDispatchers.__listenAndRespond(`${type}-call`, responseFnc, `${type}-response`);
  }
}

export default EventDrivenDispatchers;
